import { api } from "./api";
import { evidenceBaseApi } from "./evidenceBaseApi";

export interface MasterItem {
  id: string;
  name: string;
  is_active: boolean;
}

export interface ProjectCodeItem {
  id: string;
  code: string;
  is_active: boolean;
}

export interface KantataProjectItem {
  id: string;
  kantata_id: string;
  code: string | null;
  name: string;
  is_active: boolean;
  client_names: string[] | null;
}

export interface NetsuiteClientItem {
  id: string;
  netsuite_id: string;
  entity_id: string | null;
  name: string;
  is_active: boolean;
}

export const masterDataApi = {
  // Read (for dropdowns — active only)
  therapyAreas: (): Promise<MasterItem[]> => api.get("/api/master/therapy-areas"),
  projectCodes: (): Promise<ProjectCodeItem[]> => api.get("/api/master/project-codes"),
  kantataProjects: (search: string, limit = 50): Promise<KantataProjectItem[]> =>
    api.get(`/api/master/kantata-projects?search=${encodeURIComponent(search)}&limit=${limit}`),
  kantataProjectById: (id: string): Promise<KantataProjectItem> =>
    api.get(`/api/master/kantata-projects/${id}`),
  kantataProjectClients: (kantataProjectId: string): Promise<NetsuiteClientItem[]> =>
    api.get(`/api/master/kantata-projects/${kantataProjectId}/clients`),
  evidenceTypes: (): Promise<MasterItem[]> => evidenceBaseApi.evidenceTypes(),
  sourceTypes: (): Promise<MasterItem[]> => evidenceBaseApi.sourceTypes(),

  // Admin list (all records including inactive)
  adminTherapyAreas: (): Promise<MasterItem[]> => api.get("/api/admin/therapy-areas"),
  adminProjectCodes: (): Promise<ProjectCodeItem[]> => api.get("/api/admin/project-codes"),

  // Admin CRUD — therapy areas
  createTherapyArea: (name: string): Promise<MasterItem> =>
    api.post("/api/admin/therapy-areas", { name }),
  updateTherapyArea: (id: string, data: Partial<{ name: string; is_active: boolean }>): Promise<MasterItem> =>
    api.put(`/api/admin/therapy-areas/${id}`, data),
  deleteTherapyArea: (id: string): Promise<void> =>
    api.delete(`/api/admin/therapy-areas/${id}`),

  // Admin CRUD — project codes
  createProjectCode: (code: string): Promise<ProjectCodeItem> =>
    api.post("/api/admin/project-codes", { code }),
  updateProjectCode: (id: string, data: Partial<{ code: string; is_active: boolean }>): Promise<ProjectCodeItem> =>
    api.put(`/api/admin/project-codes/${id}`, data),
  deleteProjectCode: (id: string): Promise<void> =>
    api.delete(`/api/admin/project-codes/${id}`),

  // Admin CRUD — evidence types (uses Evidence Base Service)
  createEvidenceType: (name: string): Promise<MasterItem> =>
    evidenceBaseApi.createEvidenceType({ id: crypto.randomUUID(), name, is_active: true }),
  updateEvidenceType: (id: string, data: Partial<{ name: string; is_active: boolean }>): Promise<MasterItem> =>
    evidenceBaseApi.updateEvidenceType(id, data),
  deleteEvidenceType: (id: string): Promise<void> =>
    evidenceBaseApi.deleteEvidenceType(id),

  // Admin CRUD — source types (uses Evidence Base Service)
  createSourceType: (name: string): Promise<MasterItem> =>
    evidenceBaseApi.createSourceType({ id: crypto.randomUUID(), name, is_active: true }),
  updateSourceType: (id: string, data: Partial<{ name: string; is_active: boolean }>): Promise<MasterItem> =>
    evidenceBaseApi.updateSourceType(id, data),
  deleteSourceType: (id: string): Promise<void> =>
    evidenceBaseApi.deleteSourceType(id),
};
